const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Scroll Top component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */

app.directive('scrollTop', [function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.bind('click', function() {
        window.scrollTo(0, 0);
      });
    }
  };
}]);
